<template>
  <a
    :class="classes"
    :href="formattedUrl"
    v-text="title"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { env } from '@js/utils/env'

defineOptions({
  name: 'AppCourseButton',
})

const props = withDefaults(
  defineProps<{
    title: string
    classes?: string
    courseFormat?: string
    primaryCategory: string
  }>(),
  {
    courseFormat: '',
    classes: 'btn btn--outline',
  },
)

const indexName = computed(() => env.elasticsearch.SEARCH_INDEX)

const formattedUrl = computed(() => {
  // encodeURI does not encode +
  const categoryUrl = encodeURI(`${indexName.value}[menu][primary_category]=${props.primaryCategory}`)
    .replace('+','%2B')

  const formatUrl = props.courseFormat
    ? encodeURI(`&${indexName.value}[menu][course_type]=${props.courseFormat}`)
    : null

  return `/courses/calendar/all?${categoryUrl}${formatUrl}`
})
</script>
